import { StandardUserRoles } from '@quadminds/shared/commons';
import { StandardStorkRoles, StorkModules } from '../enums';

export interface IVehiclesToView {
    carrierId?: string;
    vehicleIds?: string[];
}
export interface IDriversToView {
    carrierId?: string;
    driverIds?: string[];
}

export interface IUpdateOrganizationUser {
    id: string;
    permissionsToAdd?: string[];
    permissionsToRemove?: string[];
    modulesToView?: StorkModules[];
    vehiclesToView?: IVehiclesToView[];
    driversToView?: IDriversToView[];
    roles?: (StandardStorkRoles | StandardUserRoles)[];
}
